import classNames from 'classnames';
import React from 'react';
import styles from './ReturnStepsLocations.module.scss';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import ReturnStepsLocationsSchema from './ReturnStepsLocationsSchema';
import { useTranslation } from 'react-i18next';
import MultipleRouteLocationModelSimpleText, {
    MultipleRouteLocationModelSimpleTextData,
    MultipleRouteLocationModelSimpleTextDataKeys,
} from 'fulogics-ui-web/dist/layout/components/multiple-route-location-model-simple-text/MultipleRouteLocationModelSimpleText';

const ReturnStepsLocations = (props: ReturnStepsLocationsProps) => {
    const { t } = useTranslation('ReturnStepsLocations');
    const haveData = !!props?.data?.[0];

    return (
        <div className={classNames(styles.container, props.className)}>
            {haveData ? (
                <MultipleRouteLocationModelSimpleText
                    data={props.data}
                    className={props.className}
                />
            ) : (
                <label>{t('NoData')}</label>
            )}
        </div>
    );
};

export type ReturnStepsLocationsProps = {
    data?: ReturnStepsLocationsData;
} & ReturnStepsLocationsDisplayOptions;

export default withInspector<ReturnStepsLocationsProps>(
    ReturnStepsLocations,
    ReturnStepsLocationsSchema
);

export class ReturnStepsLocationsDisplayOptions {
    className?: string;
}

export type ReturnStepsLocationsData = MultipleRouteLocationModelSimpleTextData;

export const ReturnStepsLocationsDataKeys = MultipleRouteLocationModelSimpleTextDataKeys;
